import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
    SimpleItem,
    GroupItem,
    Label,
    EmptyItem
} from 'devextreme-react/form';
import 'devextreme-react/text-area';
import UserInfo from "../UserInfo";
import { Button } from "devextreme-react";
import { criarAgentesRecebedoresDs, criarDamDs } from "../DataSources";
import uiInfo from "../ui-info";
import ShowError from "../AppServices";
import axios from "../api-axios";
import { AxisConstantLineStyle } from "devextreme-react/chart";


const template = {
    "id": undefined,
    prefeituraId: undefined,
    tipoBaixa: 1,
    damSequencial: undefined,
    exercicio: new Date().getFullYear(),
    imovelSequencial: undefined,
    numeroParcela: undefined,
    vencimento: undefined,
    valor: undefined,
    agenteRecebedorId: undefined,
    dataPagto: undefined,
    dataCredito: undefined,
    valorPago: undefined,
};

export default class BaixaManualForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = { ...template, prefeituraId: UserInfo.getPrefeitura() }
        this.saidaProgramada = false;
        template.prefeituraId = UserInfo.getPrefeitura();
        this.ok = this.ok.bind(this);
        this.cancel = this.cancel.bind(this);
        this.agentesRecebedoresDs = criarAgentesRecebedoresDs();
        this.agentesRecebedoresOpcoes = {
            editorType: "dxSelectBox",
            searchEnabled: false,
            dataSource: criarAgentesRecebedoresDs(),
            placeholder: " ",
            valueExpr: "id",
            displayExpr: "descricao",
            showClearButton: true
        };
        this.tipoBaixaOpcoes = {
            editorType: "dxSelectBox",
            searchEnabled: false,
            dataSource: [
                { id: 1, descricao: "GERAL" },
                { id: 2, descricao: "IPTU" }
            ],
            placeholder: " ",
            valueExpr: "id",
            displayExpr: "descricao",
            onValueChanged: (e) => {
                console.log(e);
                this.setState({ tipoBaixa: e.value });
            }
        }
        this.pesquisarParcela = this.pesquisarParcela.bind(this);
        this.damDs = criarDamDs();
        this.formFieldDataChanged = this.formFieldDataChanged.bind(this);
        this.formRef = React.createRef();
        this.excluirBaixa = this.excluirBaixa.bind(this);
    }

    formFieldDataChanged(e) {

        const campoAtualizado = e.dataField;
        if (campoAtualizado === "damSequencial" || campoAtualizado === "imovelSequencial" || campoAtualizado === "numeroParcela" || campoAtualizado === "exercicio") {
            this.pesquisarParcela();
        }
    }

    pesquisarParcela() {

        if (this.state.tipoBaixa === 1 && this.state.damSequencial == undefined) {
            return;
        }

        if (this.state.tipoBaixa === 2 && (this.state.exercicio == undefined || this.state.imovelSequencial == undefined || this.state.numeroParcela == undefined)) {
            return;
        }

        const filtro = {
            prefeituraId: UserInfo.getPrefeitura(),
            tipo: this.state.tipoBaixa,
            damSequencial: this.state.damSequencial,
            exercicio: this.state.exercicio,
            imovelSequencial: this.state.imovelSequencial,
            parcela: this.state.numeroParcela
        }

        axios.post("dam/obter_dam_baixa_manual", filtro)
            .then(resp => {
                console.log("resposta", resp);
                this.setState({ vencimento: resp.data.vencimento, valor: resp.data.valor });
            })
            .catch(error => {
                const response = error.response;
                const data = response.data;
                if (response.status !== 404) {
                    // ShowError(data);
                }
                console.log(this.formRef);
                this.setState({ vencimento: null, valor: null });
                console.log(this.state);
            });
    }

    componentDidMount() {
        this.setState({ ...template })
    }

    render() {

        return (
            <React.Fragment>
                <div className={'content-block dx-card responsive-paddings'}>
                    <form>
                        <Form formData={this.state} colCount={2} ref={this.formRef} onFieldDataChanged={this.formFieldDataChanged}>
                            <GroupItem caption="BAIXA MANUAL" colSpan={2} colCount={4}>

                                <SimpleItem colSpan={4} dataField="tipoBaixa" editorType={"dxSelectBox"} editorOptions={this.tipoBaixaOpcoes}>
                                    <Label text="Tipo de Baixa" />
                                </SimpleItem>

                                <SimpleItem colSpan={1} dataField={"damSequencial"} editorType={"dxNumberBox"} visible={this.state.tipoBaixa === 1}>
                                    <Label text="Código Interno" />
                                </SimpleItem>

                                <EmptyItem colSpan={3} visible={this.state.tipoBaixa === 1} />

                                <SimpleItem colSpan={1} dataField={"exercicio"} editorType={"dxNumberBox"} visible={this.state.tipoBaixa === 2}>
                                    <Label text="Exercício" />
                                </SimpleItem>

                                <EmptyItem colSpan={3} visible={this.state.tipoBaixa === 2} />

                                <SimpleItem colSpan={1} dataField={"imovelSequencial"} editorType={"dxNumberBox"} visible={this.state.tipoBaixa === 2}>
                                    <Label text="Imóvel" />
                                </SimpleItem>

                                <EmptyItem colSpan={3} visible={this.state.tipoBaixa === 2} />

                                <SimpleItem colSpan={1} dataField={"numeroParcela"} editorType={"dxNumberBox"} visible={this.state.tipoBaixa === 2}>
                                    <Label text="Parcela" />
                                </SimpleItem>

                                <EmptyItem colSpan={3} visible={this.state.tipoBaixa === 2} />

                                <SimpleItem colSpan={1} dataField={"vencimento"} editorType={"dxDateBox"} editorOptions={{ width: "100%", readOnly: true }}>
                                    <Label text="Vencimento" />
                                </SimpleItem>

                                <EmptyItem colSpan={3} />

                                <SimpleItem colSpan={1} dataField={"valor"} editorType={"dxNumberBox"} editorOptions={{ readOnly: true, format: uiInfo.formatoNumerico.n2 }} cssClass={"txtNumerico"}>
                                    <Label text="Valor" />
                                </SimpleItem>

                            </GroupItem>

                            <GroupItem caption="INFORMAÇÕES DA BAIXA MANUAL" colSpan={2} colCount={4}>

                                <SimpleItem colSpan={4} dataField="agenteRecebedorId" editorType={"dxSelectBox"} editorOptions={this.agentesRecebedoresOpcoes}>
                                    <Label text="Inst. Financeira" />
                                </SimpleItem>

                                <SimpleItem colSpan={1} dataField={"dataPagto"} editorType={"dxDateBox"} editorOptions={{ width: "100%" }}>
                                    <Label text="Data de Pagamento" />
                                </SimpleItem>
                                <EmptyItem colSpan={3} />

                                <SimpleItem colSpan={1} dataField={"dataCredito"} editorType={"dxDateBox"} editorOptions={{ width: "100%" }}>
                                    <Label text="Data de Crédito" />
                                </SimpleItem>
                                <EmptyItem colSpan={3} />

                                <SimpleItem colSpan={1} dataField={"valorPago"} editorType={"dxNumberBox"} editorOptions={{ format: uiInfo.formatoNumerico.n2 }} cssClass={"txtNumerico"}>
                                    <Label text="Valor Pago" />
                                </SimpleItem>
                                <EmptyItem colSpan={3} />

                            </GroupItem>

                        </Form>
                        <div style={{ marginTop: "10px" }}>
                            <div style={{ display: "inline-block" }}>
                                <Button
                                    width={120}
                                    text="Salvar"
                                    type="success"
                                    onClick={this.ok}
                                />

                            </div>
                            <div style={{ display: "inline-block", marginLeft: "10px" }}>
                                <Button

                                    text="Cancelar"
                                    onClick={this.cancel}
                                />
                            </div>
                            <div style={{ display: "inline-block", marginLeft: "10px" }}>
                                <Button
                                    type={"danger"}
                                    text="Excluir Baixa"
                                    onClick={this.excluirBaixa}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </React.Fragment>
        );

    }

    ok() {
        axios.post("dam/baixa_manual", this.state)
            .then(resp => {
                notify("Baixa realizada com sucesso", "success");
                const form = this.formRef.current.instance;
                const novoEstado = { ...template, prefeituraId: UserInfo.getPrefeitura() };
                //this.setState(novoEstado, () => this.formRef.current.instance.getEditor("tipoBaixa").focus());
                //form.option("formData", novoEstado);
                form.updateData(novoEstado);
                form.getEditor("tipoBaixa").focus();
                console.log(this.state);

            })
            .catch(error => {
                console.log(error);
                var resp = error.response;

                if (resp != undefined) {
                    console.log(resp);
                    if (resp.status === 400) {
                        ShowError(resp.data);
                    }
                }
                else {
                    ShowError(error);
                }


            });
    }

    cancel() {
        notify("Operação cancelada", "warning");
        this.props.history.goBack();
    }

    excluirBaixa() {
        if (this.state.damSequencial == undefined) {
            ShowError("Informe o código do DAM a ser excluído   ");
        }
        axios.post("dam/excluir_baixa_manual", this.state)
            .then(_ => {
                notify("Baixa excluída com sucesso", "success");
                const form = this.formRef.current.instance;
                const novoEstado = { ...template, prefeituraId: UserInfo.getPrefeitura() };
                form.updateData(novoEstado);
                form.getEditor("tipoBaixa").focus();
                console.log(this.state);

            })
            .catch(error => {
                console.log(error.response);
                if (error.response && error.response.data && error.response.data.erros) {
                    ShowError(error.response.data.erros);
                }
                else {
                    ShowError(error.response.data);
                }
            });
    }
}